import { defineAction } from 'redux-define';

const CANCELLED = 'CANCELLED';
const ERROR = 'ERROR';
const PENDING = 'PENDING';
const SUCCESS = 'SUCCESS';

export const BOOTING = defineAction(
  'BOOTING',
  [CANCELLED, ERROR, PENDING, SUCCESS],
  'claro/Music',
);

export const LOAD_CONFIG = defineAction(
  'LOAD_CONFIG',
  [CANCELLED, ERROR, PENDING, SUCCESS],
  'claro/Music',
);

export const LOAD_SESSION = defineAction(
  'LOAD_SESSION',
  [CANCELLED, ERROR, PENDING, SUCCESS],
  'claro/Music',
);

export const LOGOUT = defineAction('LOGOUT', [], 'claro/Music');

export const LOAD_PLAYLISTS = defineAction(
  'LOAD_PLAYLIST',
  [CANCELLED, ERROR, PENDING, SUCCESS],
  'claro/Music',
);

export const SESSION_COOKIE_CONFIG = {
  name: 'app_music_session',
  options: { expires: 12 },
};
